import {
  Layout,
  SkeletonPage,
  SkeletonPageProps,
  Loading as LoadingShopify,
  SkeletonTabs,
  SkeletonBodyText,
  SkeletonDisplayText,
  TextContainer,
  LegacyCard,
} from "@shopify/polaris";
import React from "react";

interface Props {
  pageProp: SkeletonPageProps;
  tabs?: boolean;
  card?: boolean;
}

export function Loading(props: Props) {
  return (
    <div>
      <LoadingShopify />
      {(props.tabs || props.card) && (
        <SkeletonPage {...props.pageProp}>
          <Layout>
            <Layout.Section>
              {props.tabs ? (
                props.card ? (
                  <LegacyCard>
                    <SkeletonTabs />
                    <LegacyCard.Section>
                      <TextContainer>
                        <SkeletonDisplayText size="small" />
                        <SkeletonBodyText lines={9} />
                      </TextContainer>
                    </LegacyCard.Section>
                  </LegacyCard>
                ) : (
                  <>
                    <SkeletonTabs />
                    <br />
                    <TextContainer>
                      <SkeletonDisplayText size="small" />
                      <SkeletonBodyText lines={9} />
                    </TextContainer>
                  </>
                )
              ) : (
                <></>
              )}
            </Layout.Section>
          </Layout>
        </SkeletonPage>
      )}
    </div>
  );
}
